<div class="imageOverFlow">
  <div
    class="icon-alignment px-2"
    [ngbTooltip]="tipContent"
    container="body"
    tooltipClass="icon-grid-tooltip"
    data-bs-placement="auto"
  >
    <i
      class="fa fa-star"
      [ngClass]="params.data.isBookmarked ? 'fa-star bookMarkClass' : 'fa-star-o unbookmarkClass'"
      aria-hidden="true"
      (click)="updateBookmark()"
    ></i>
    <ng-template #tipContent>
      <div class="row">
        <div class="col">
          <span
            >{{ params.data.isBookmarked ? 'Click to remove bookmark' : 'Click to add bookmark' }}
          </span>
        </div>
      </div>
    </ng-template>
  </div>
</div>
